const Batch = {
  queryList: [
    {
      name: 'degreeType',
      label: '学位类型',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confDegreeType/queryDegreeTypeList',
        data: {},
        format: {
          value: 'id',
          label: 'name'
        }
      }
    }
  ],
  urlMap: {
    select: '/school/schoolAuditPlanConfig/list',
    setDefaultAuditPlan: '/school/schoolAuditPlanConfig/setDefaultAuditPlan/{id}',
    delete: '/school/schoolAuditPlanConfig/deleteById/{id}'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        kind: 'primary', // error
        type: 'subRouter', // request, router, dialog, func
        addr: 'configManage/templateOfReview'
      }
    }
  ],
  titles: [
    {
      name: 'auditPlanName',
      label: '评阅规则名称'
    },
    {
      name: 'defaultTemplate',
      label: '是否默认',
      map: {
        0: '否',
        1: '是'
      }
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '编辑',
          name: 'edit',
          width: 800,
          kind: 'primary', // error
          type: 'subRouter', // request, router, dialog, func
          addr: 'configManage/templateOfReview?{id}'
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: ['{id}'],
          confirm: {
            desc: '确认删除？'
          }
        },
        {
          label: '设置为默认评阅规则',
          kind: 'primary',
          type: 'request',
          addr: 'setDefaultAuditPlan',
          data: ['{id}'],
          confirm: {
            desc: '确认设置为默认评阅规则？'
          }
        }
      ]
    }
  ]
}
export default Batch



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/configManage/fuReviewRuleConfig.js